import PropTypes from 'prop-types';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Routes, Route, useLocation } from "react-router-dom";
import { layoutTypes } from "./constants/layout";
import { authProtectedRoutes, publicRoutes } from "./routes";
import Authmiddleware from "./routes/route";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import PublicLayout from "./components/PublicLayout";
import "./assets/scss/theme.scss";
import { setThemeColor, fetchProfile } from 'store/actions';
import RoleGuard from 'components/RoleGuard';
import Footer from 'components/Footer';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = VerticalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const App = () => {

  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch])

  useEffect(() => {
    const saved = localStorage.getItem("themeColor");
    if (saved) dispatch(setThemeColor(saved));
  }, [dispatch])

  const selectLayoutState = (state) => state.Layout;
  const LayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutType: layout.layoutType,
    })
  );

  const {
    layoutType
  } = useSelector(LayoutProperties);

  const Layout = getLayout(layoutType);

  const marketingPaths = [
    "/",
    "/products",
    "/resources",
    "/about",
    "/media",
    "/info-hub",
    "/contact",
    "/sample-submission",
    "/terms",
  ].reduce((acc, path) => acc.add(path), new Set());

  const heightForPath = (path) => {
    if (!path) return undefined;
    if (path === "/add-resource") {
      return "40vh";
    }

    if ( path === "/add-company") {
      return "50vh";
    }

    if (path === "/add-user") {
      return "47vh";
    }

    if (path === "/profile") {
      return "18vh";
    }

    return undefined;
  };

  const footerHeight = heightForPath(location.pathname);

  return (
    <React.Fragment>
      <ToastContainer position="top-right" autoClose={4000} newestOnTop />
      <Routes>
        {publicRoutes.map((route, idx) => {
          const Wrapper = marketingPaths?.has(route.path) ? PublicLayout : NonAuthLayout;
          return (
            <Route
              key={`pub-${idx}`}
              path={route.path}
              element={<Wrapper>{route.component}</Wrapper>}
            />
          );
        })}

        {authProtectedRoutes?.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <Authmiddleware>
                <RoleGuard roles={route.roles}>
                  <Layout>
                    {route.component}
                    <Footer height={footerHeight} />
                  </Layout>
                </RoleGuard>
              </Authmiddleware>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

export default App;